export const Version = {
	version: '1.45.0.5',
};
